// Event-Listener für das Resize-Event
 /*window.addEventListener("resize", () => {
  // Überprüfen Sie, ob die Viewport-Breite größer als 750px ist
  if (window.innerWidth > 780 || window.innerHeight < 500 ) {
    // Warten Sie 1 Sekunde, bevor Sie die Seite neu laden
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}); 
*/

// Beginn Modal
        document.querySelectorAll('.modal-link').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                const modal = document.getElementById('myModal');
                const my1Iframe = modal.querySelector('iframe');
              const maHeader=document.querySelector('sticky-header');
              const buttonBeacon=document.getElementById('button-beacon');
                /* modal.querySelector.('h6').textContent = link.getAttribute('modal-head'); */
                my1Iframe.src = link.getAttribute('data-link');
                modal.style.display = 'block';
                //modal.setAttribute('aria-hidden', 'false');
                maHeader.style.display = 'none';
                buttonBeacon.style.display = 'none';
            });
        });

        document.querySelector('.close').addEventListener('click', () => {
            const modal = document.getElementById('myModal');
            const my1Iframe = modal.querySelector('iframe');
            const maHeader=document.querySelector('sticky-header');
            const buttonBeacon=document.getElementById('button-beacon');
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            maHeader.style.display= 'block';
            buttonBeacon.style.display = 'block';
            my1Iframe.src = my1Iframe.src;        
            my1Iframe.src = "";
        });

        window.addEventListener('click', event => {
            const modal = document.getElementById('myModal');
            const maHeader=document.querySelector('sticky-header');
            const buttonBeacon=document.getElementById('button-beacon');
            if (event.target === modal) {
                const my1Iframe = modal.querySelector('iframe');
                modal.style.display = 'none';
                my1Iframe.src = my1Iframe.src;
              
                my1Iframe.src = "";
                //modal.setAttribute('aria-hidden', 'true');
                maHeader.style.display = 'block';
                buttonBeacon.style.display = 'block';
            }
        });
// Ende Modal